import {Component, OnInit} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {AuthActivityLogService} from "../../services/auth-activity-log.service";
import {ActivityLogView} from "../../../stp-operations/services/stp-activity-log.service";

interface SearchCriteria {
  username: string;
  operation: string;
  startDate: string;
  endDate: string;
  page: number;
  size: number;
}


interface DiffRow {
  key: string;
  oldVal: any;
  newVal: any;
  changed: boolean;
}

interface KVRow {
  key: string;
  value: any;
}


@Component({
  selector: 'app-auth-activity-log',
  templateUrl: './auth-activity-log.component.html',
  styleUrls: ['./auth-activity-log.component.scss']
})
export class AuthActivityLogComponent implements OnInit {


  logsList: ActivityLogView[] = [];
  total = 0;
  loading = false;


  searchCriteria: SearchCriteria = {
    username: '',
    operation: '',
    startDate: '',
    endDate: '',
    page: 1,
    size: 10
  };


  dateRange: [Date, Date] | null = null;
  isPreviewVisible = false;
  modalTitle = '';
  detailList: DiffRow[] = [];
  kvList: KVRow[] = [];
  isInsert = false;
  isUpdate = false;
  isDelete = false;

  clientIp: string = '103.92.84.50';

  constructor(private authActivityLogService: AuthActivityLogService) {
  }

  ngOnInit(): void {
    this.loadTableData();
  }


  private formatDate(d: Date): string {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  onDateRangeChange(): void {
    if (this.dateRange?.[0] && this.dateRange?.[1]) {
      this.searchCriteria.startDate = this.formatDate(this.dateRange[0]);
      this.searchCriteria.endDate = this.formatDate(this.dateRange[1]);
    } else {
      this.searchCriteria.startDate = '';
      this.searchCriteria.endDate = '';
    }
  }

  loadTableData(): void {
    this.onDateRangeChange();
    this.loading = true;
    this.authActivityLogService
      .getAuthActivityLog({
        username: this.searchCriteria.username,
        operation: this.searchCriteria.operation,
        startDate: this.searchCriteria.startDate,
        endDate: this.searchCriteria.endDate,
        page: this.searchCriteria.page,
        size: this.searchCriteria.size
      })
      .pipe(
        catchError(err => {
          return of({content: [], totalElements: 0});
        })
      )
      .subscribe((res: any) => {
        this.logsList = res.content.map((log: any) => {
          let oldObj = {};
          let newObj = {};

          try {
            oldObj = log.oldData ? JSON.parse(log.oldData) : {};
          } catch (e) {
          }

          try {
            newObj = log.newData ? JSON.parse(log.newData) : {};
          } catch (e) {
          }

          return {
            ...log,
            oldData: oldObj,
            newData: newObj
          };
        });

        this.total = res.totalElements;
        this.loading = false;
      });
  }

  openComparisonModal(log: any): void {
    const op = (log.operation || '').toUpperCase();
    this.isInsert = op === 'INSERT';
    this.isUpdate = op === 'UPDATE';
    this.isDelete = op === 'DELETE';

    this.modalTitle = this.isInsert ? 'Inserted Data'
      : this.isUpdate ? 'Updated Data'
        : this.isDelete ? 'Deleted Data'
          : `${op.charAt(0) + op.slice(1).toLowerCase()} Data`;

    const oldObj = log.oldData || {};
    const newObj = log.newData || {};

    if (this.isInsert || this.isUpdate) {
      const keys = Array.from(new Set([...Object.keys(oldObj), ...Object.keys(newObj)]))
        .filter(key => {
          const oldVal = oldObj[key];
          const newVal = newObj[key];
          const isEmpty = (v: any) => v === undefined || v === null || v === '';
          return !(isEmpty(oldVal) && isEmpty(newVal));
        });

      this.detailList = keys.map(key => {
        const oldVal = oldObj[key] ?? '';
        const newVal = newObj[key] ?? '';
        const changed = this.isUpdate
          ? JSON.stringify(oldVal) !== JSON.stringify(newVal)
          : false;
        return {key, oldVal, newVal, changed};
      });
    }

    if (this.isDelete) {
      this.kvList = Object.entries(oldObj)
        .filter(([_, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => ({key: k, value: v}));
    }

    this.isPreviewVisible = true;
  }


  handleCancel(): void {
    this.isPreviewVisible = false;
  }

  onPageIndexChange(newPage: number): void {
    this.searchCriteria.page = newPage;
    this.loadTableData();
  }

  onPageSizeChange(newSize: number): void {
    this.searchCriteria.size = newSize;
    this.searchCriteria.page = 1;
    this.loadTableData();
  }

  getStartIndex(): number {
    return (this.searchCriteria.page - 1) * this.searchCriteria.size + 1;
  }

  getEndIndex(): number {
    const end = this.searchCriteria.page * this.searchCriteria.size;
    return end > this.total ? this.total : end;
  }

  onRefresh(): void {
    this.dateRange = null;
    this.searchCriteria.username = '';
    this.searchCriteria.operation = '';
    this.searchCriteria.startDate = '';
    this.searchCriteria.endDate = '';
    this.searchCriteria.page = 1;
    this.loadTableData();
  }


}
